import { useEffect, useState } from "react";
import { initLazyPayPayment, verifyLazyPayOtp } from "../../Redux/Actions";
import { LAZYPAY_VIEWS, TRANSACTION_ID } from "../../Constants";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/Reducers";
import LazyPayLogo from "../../Assets/images/lazypay_.png";
import { clevertapEventPush } from "../../Utils/common";

const LazyPayAuth = (props: any): JSX.Element => {
  let timerID: any = null;
  const dispatch = useDispatch();
  const [state, setState] = useState<any>({
    phone: "",
    OTP: "",
    OTPsent: false,
    timer: 59,
    isTimeUp: false,
    showIncorrectOtpErr: false,
  });

  const { lazyPayAuth, prePaymentData } = useSelector((state: RootState) => ({
    lazyPayAuth: state.paymentMethodReducer.lazyPayAuth,
    prePaymentData: state.paymentMethodReducer.prePaymentData,
  }));

  useEffect(() => {
    if (lazyPayAuth?.show && lazyPayAuth?.view === LAZYPAY_VIEWS.OTP) {
      setState((state: any) => ({ ...state, OTPsent: true }));
    }
  }, [lazyPayAuth?.show]);
  useEffect(() => {
     if (props.selectedOption!=='LAZYPAY' && state.OTP.length>0){
        setState((state: any) => ({ ...state, OTP:"" }));
     }
  }, [props?.selectedOption]);
  useEffect(() => {
    if (state.OTPsent) {
      startTimer();
    }

    return () => {
      /** Clear the Intereval if any */
      if (timerID != null) {
        clearInterval(timerID);
      }
    };
  }, [state.OTPsent]);

  // Start the timmer
  const startTimer = () => {
    let seconds = state.timer;
    timerID = setInterval(() => tick(--seconds), 1000);
  };

  // Increase the timing (second) tick
  const tick = (seconds: number) => {
    let updatedTime: string;
    if (seconds > 0) {
      updatedTime = (seconds < 10 ? "0" : "") + String(seconds);
      setState((state: any) => ({
        ...state,
        timer: updatedTime,
      }));
    } else {
      clearInterval(timerID);
      setState((state: any) => ({
        ...state,
        timer: 59,
        isTimeUp: true,
      }));
    }
  };

  const resendOTP = () => {
    if (!state.isTimeUp) {
      return;
    }

    setState((state: any) => ({ ...state, isTimeUp: false, OTP:"" }));
    dispatch(initLazyPayPayment({ ...prePaymentData, credit_used: props.creditsUsed || 0 }));
    let seconds = state.timer;
    timerID = setInterval(() => tick(--seconds), 1000);
  };

  const handleChange = (val: any) => {
    if (!val.match(/[a-zA-Z0-9]/)){
      return;
    }
    const alphanumericVal = val.replace(/[^a-zA-Z0-9]/g, '');
    setState((state: any) => ({ ...state, OTP: alphanumericVal}));
  };

  const onPayBtnHandle = () => {
    dispatch(
      verifyLazyPayOtp({
        transactionId: sessionStorage.getItem(TRANSACTION_ID),
        otp: state.OTP,
        requestType: "pay",
      }),
    );
  };

  const _renderNotEligibleView = (): JSX.Element => {
    return (
      <div>
        <p className="mv0">
          <img src={LazyPayLogo} loading="lazy" alt="lazypay image" />
        </p>
        <p className="f5">
          Currently we don’t have LazyPay method eligible for you. Please select another payment method
        </p>
      </div>
    );
  };

  const _renderOTPView = (): JSX.Element => {
    return (
      <div>
        <p className="w-100 fw6 mt0">Enter OTP sent to ‘{prePaymentData?.phone}’ & Pay</p>
        <OtpInput
          value={state.OTP}
          onChange={(otp: any) => handleChange(otp)}
          numInputs={4}
          separator={<span></span>}
          containerStyle={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gridColumnGap: 0,
            width: "fit-content",
            marginTop: 20,
          }}
          shouldAutoFocus={true}
          inputStyle={{
            width: 44,
            height: 44,
            border: "1px solid #707070",
            borderRadius: 4,
            boxShadow: "none",
            outline: "none",
            marginRight: 20,
          }}
        />
        {state.showIncorrectOtpErr && <p className="f14px red">Incorrect OTP, entered please enter again.</p>}
        <span
          className="timer f14px mb2"
          style={{
            marginTop: "20px",
            display: "block",
          }}
        >
          <label className={`fw5 mr2 ${state.isTimeUp ? "amaranth-color " : "black-30"}`} onClick={resendOTP}>
            Resend OTP
          </label>
          {!state.isTimeUp && <label className="fw5 o-30">in {`0:${state.timer} s`}</label>}
        </span>
        <button className="bg-amaranth-color white w-100 mt3 br4 bn fw6 pv3" onClick={onPayBtnHandle}>
          CONFIRM & PAY
        </button>
      </div>
    );
  };

  const _renderEligibleView = (): JSX.Element => {
    return (
      <div>
        <p className="mv0">
          <img src={LazyPayLogo} loading="lazy" alt="lazypay image" />
        </p>
        <p className="fw6" style={{ fontSize: 20 }}>
          Confirm your payment with LazyPay
        </p>
        <p className="fw6">₹ {prePaymentData?.amount}</p>
        <button className="bg-amaranth-color white w-100 mt3 br4 bn fw6 pv3" onClick={props.onClose}>
          CONFIRM & PAY
        </button>
      </div>
    );
  };

  const _renderView = (type: any): JSX.Element => {
    switch (type) {
      case LAZYPAY_VIEWS.OTP:
        return _renderOTPView();
      case LAZYPAY_VIEWS.ELIGIBLE:
        return _renderEligibleView();
      default:
        return _renderNotEligibleView();
    }
  };

  return <section className="pa3">{_renderView(lazyPayAuth?.view)}</section>;
};

export default LazyPayAuth;
